import { Divider } from 'antd'
import { Campaign } from 'src/core/models'
import { CustomTable } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import React, { useState, useEffect } from 'react'
import { campaingsStateSelector } from 'src/features'
import { getCampaingsFiltered } from 'src/core/helpers'
import { campaignsColumns } from 'src/core/table-columns'
import styles from './DiscountVouchersPageContent.module.scss'
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import CampaignListHeader from './CampaignListHeader/CampaignListHeader'
import DiscountVouchersList from './DiscountVouchersList/DiscountVouchersList'

const DiscountVouchersPageContent: React.FC = () => {
  const { data: campaings } = useAppSelector(campaingsStateSelector)
  const [filteredCampaings, setFilteredCampaings] = useState<Campaign[]>(campaings)
  const [filterText, setFilterText] = useState<string>(null)

  useEffect(() => {
    const newCampaings = getCampaingsFiltered(filterText, campaings)
    setFilteredCampaings(newCampaings)
  }, [filterText, campaings])

  const renderExpandedRow = (campaign: Campaign) => (
    <DiscountVouchersList
      campaign={campaign}
    />
  )

  const renderExpandIcon = ({ expanded, onExpand, record }) => {
    const Icon = expanded ? DownOutlined : RightOutlined
    return <Icon onClick={(e) => onExpand(record, e)} className={styles.icon} />
  }

  const tableProps = {
    dataSource: filteredCampaings,
    columns: campaignsColumns,
    rowKey: (campaign: Campaign) => campaign.id,
    rowClassName: 'fade-animation pointer',
    expandIcon: renderExpandIcon,
    expandable: {
      expandRowByClick: true,
      expandedRowRender: renderExpandedRow,
    },
  }

  return <>
    {/* Header */}
    <CampaignListHeader
      text={filterText}
      length={filteredCampaings.length}
      onTextChange={(value: string) => setFilterText(value)}
    />
    <Divider />
    {/* Table */}
    <CustomTable {...tableProps} />
  </>
}

export default DiscountVouchersPageContent
